import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* createOrUpdateBlog() {
  yield takeEvery(actions.CREATE_OR_UPDATE_BLOG_REQUESTED, function* (action) {
    try {
      const blog = yield call(actions.createOrUpdateBlog, action.payload);
      yield put({ type: actions.CREATE_OR_UPDATE_BLOG_SUCCEEDED, blog });
    } catch (error) {
      yield put({
        type: actions.CREATE_OR_UPDATE_BLOG_FAILED,
        error: error.response.data.message,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(createOrUpdateBlog)]);
}
